module.exports = __webpack_public_path__ + "img/powered-by-stripe-solid-dark.0a03a27c.svg";